import PropTypes from "prop-types";
import PaginationComponent from "./PaginationComponent";
import { Col, Form, Row } from "react-bootstrap";

const TableLimitPagination = ({ data, paginationProps }) => {
  const {
    rowsPerPage,
    rowCount,
    currentPage,
    onChangePage,
    paginationComponentOptions = {
      rowsPerPageText: "จำนวนต่อหน้า",
      rangeSeparatorText: "จาก",
      noRowsPerPage: false,
      selectAllRowsItem: false,
      selectAllRowsItemText: "ทั้งหมด"
    },
    paginationRowsPerPageOptions = [10, 15, 20, 30],
    onChangeRowsPerPage
  } = paginationProps;
  const firstRow = (currentPage - 1) * rowsPerPage + 1;
  const lastRow = Math.min(currentPage * rowsPerPage, rowCount);

  return (
    !!data?.length &&
    <nav className="rdt_Pagination mt-2 d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center">
      <Row className="text-secondary">
        <Form.Label
          column
          xs={5}
          className="pe-0 text-truncate fs-6 d-flex align-items-center"
        >
          {paginationComponentOptions.rowsPerPageText}
        </Form.Label>
        <Col className="px-0 text-truncate" style={{ maxWidth: "50px" }}>
          <Form.Select
            className="text-secondary border-0 fs-6"
            onChange={(e) => onChangeRowsPerPage(+e.target.value)}
            value={rowsPerPage}
          >
            {paginationRowsPerPageOptions.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </Form.Select>
        </Col>
        <Form.Label
          column
          className="ps-0 text-truncate fs-6 d-flex align-items-center"
        >
          {`${firstRow}-${lastRow} ${paginationComponentOptions.rangeSeparatorText} ${rowCount}`}
        </Form.Label>
      </Row>

      <PaginationComponent
        data={new Array(rowCount)}
        currentPage={Number(currentPage)}
        itemsPerPage={Number(rowsPerPage)}
        onPageChange={(page) => page != currentPage && onChangePage(page)}
      />
    </nav>
  );
};

TableLimitPagination.propTypes = {
  data: PropTypes.array,
  paginationProps: PropTypes.object.isRequired
};

export default TableLimitPagination;
